const gladlyConfig = {
    options: {
        appId: 'rei.com',
    },
    functionName: 'rei-gladly',
    selector: 'gladly-button',
    environment: 'STAGING',
    startChatButton: true,
    autoDisplayChat: true,
    autoConfig: true,
};

export default gladlyConfig;
